import Date from './Date';
import DefaultAttribute from './DefaultAttribute';
import { IProfessionalQualificationAttribute } from '@medely/types';
import Image from './Image';
import React from 'react';
import State from './State';
import Text from 'components/credentials/attributeFields/Text';
import Pdf from './Pdf';
import { TbType, YesNoString } from './TbTypes';
import SignedDocument from './SignedDocument';

type DisplayAttributeComponent = React.ComponentType<{
  attribute: IProfessionalQualificationAttribute;
  'data-testid'?: string;
}>;

const COMPONENT_MAPPING: Record<string, DisplayAttributeComponent> = {
  boolean: YesNoString,
  date: Date,
  enumerable: TbType,
  expiration_date: Date,
  image_back: Image,
  image_front: Image,
  pdf: Pdf,
  signed_document: SignedDocument,
  state: State,
  // Text expects form-field props (name/isRequired/label), not the display `attribute` prop
  // used here; kept as-is to preserve existing behavior for this field type.
  text: Text as unknown as DisplayAttributeComponent,
  valid_date: Date,
};

type AttributeProps = {
  attribute: Partial<IProfessionalQualificationAttribute>;
};

const Attribute = ({ attribute }: AttributeProps) => {
  const fieldType = attribute.qualification_attribute?.field_type;
  const Component = fieldType ? COMPONENT_MAPPING[fieldType] : undefined;
  return !!Component ? (
    <Component
      attribute={attribute as IProfessionalQualificationAttribute}
      data-testid="attribute"
    />
  ) : (
    <DefaultAttribute attribute={attribute} />
  );
};

export default Attribute;
